function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import Account from 'modules/Account';
import { ActivePatients, SearchPatients } from 'modules/Hcp';
import messages from '../../messages';
import styles from './DownloadDataModal.pcss';
const PatientsHeader = ({ onSetComponent })=>{
    const onAddPatient = ()=>onSetComponent('AddPatient');
    return /*#__PURE__*/ _jsx("div", {
        className: styles.patients__head,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row align-items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx("h3", {
                        className: "modal__subheader ",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.choosePatient.listHeader))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col text--right",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "transparent",
                        labelMessage: messages.buttons.addPatient,
                        className: "btn--no-size text--primary m-0",
                        onClick: onAddPatient
                    })
                })
            ]
        })
    });
};
const PatientsList = ({ onSetComponent })=>{
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const onChoosePatient = ()=>onSetComponent('DownloadSummary');
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.patients__searchContainer,
                children: /*#__PURE__*/ _jsx(SearchPatients, {
                    forId: "meterList"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.patients__listContainer,
                children: /*#__PURE__*/ _jsx(ActivePatients, {
                    id: "meterList",
                    activeClinicMembership: activeClinicMembership,
                    styleModifier: "halfSpace",
                    isWithoutLoad: true,
                    onClick: onChoosePatient
                })
            })
        ]
    });
};
const Patients = ({ onSetComponent })=>/*#__PURE__*/ _jsxs("div", {
        className: styles.patients,
        children: [
            /*#__PURE__*/ _jsx(PatientsHeader, {
                onSetComponent: onSetComponent
            }),
            /*#__PURE__*/ _jsx(PatientsList, {
                onSetComponent: onSetComponent
            })
        ]
    });
const ChoosePatient = ({ onSetComponent, onSetHeaderMessage, onCancel })=>{
    useEffect(()=>{
        onSetHeaderMessage(messages.choosePatient.header);
        return ()=>onSetHeaderMessage();
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.choosePatient.info))
            }),
            /*#__PURE__*/ _jsx(Patients, {
                onSetComponent: onSetComponent
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.buttons.cancelImport,
                className: "btn--block mb-0",
                onClick: onCancel
            })
        ]
    });
};
export default ChoosePatient;
